const setRecommendations = RECOMMENDATIONS => ({ RECOMMENDATIONS });
const setHeader = HEADER => ({ HEADER });
const setFooter = FOOTER => ({ FOOTER });
const setDailySpecials = DAILYSPECIALS => ({ DAILYSPECIALS });
const setYourOffers = YOUR_OFFERS => ({ YOUR_OFFERS });
const setSimilarToYou = SIMILAR_TO_YOU => ({ SIMILAR_TO_YOU });


module.exports = ({
  FRAGMENT_RECOMMENDATIONS,
  FRAGMENT_HEADER,
  FRAGMENT_FOOTER,
  FRAGMENT_DAILYSPECIALS,
  FRAGMENT_SIMILAR_TO_YOU,
  FRAGMENT_YOUR_OFFERS
}) => ({
  ...setRecommendations(FRAGMENT_RECOMMENDATIONS),
  ...setHeader(FRAGMENT_HEADER),
  ...setFooter(FRAGMENT_FOOTER),
  ...setDailySpecials(FRAGMENT_DAILYSPECIALS),
  ...setSimilarToYou(FRAGMENT_SIMILAR_TO_YOU),
  ...setYourOffers(FRAGMENT_YOUR_OFFERS)
});
